module.exports = __webpack_public_path__ + "img/layer-20@2x.d737fad1.png";